<ng-container
    *ngIf="
        purchasedProduct &&
        purchasedProduct?.coverage &&
        (purchasedProduct?.coverage?.additionalCoverages || purchasedProduct?.coverage?.baseCoverages)
    "
>
    <h3>Dekking & Premie</h3>
    <ins-insurance-coverage-data-list
        *ngIf="!purchasedProduct?.coverage?.coveragesAdjustmentStartDate"
        [purchasedProduct]="purchasedProduct"
        [display]="coverageDisplayEnum.Current"
    ></ins-insurance-coverage-data-list>

    <ng-container
        *ngIf="purchasedProduct?.coverage?.coveragesAdjustmentStartDate"
        [ngSwitch]="purchasedProduct?.product?.validityStatusCode"
    >
        <ng-container *ngSwitchCase="validityStatusCodeEnum.Future">
            <ins-insurance-coverage-data-list
                [purchasedProduct]="purchasedProduct"
                [display]="coverageDisplayEnum.Future"
            ></ins-insurance-coverage-data-list>
        </ng-container>
        <ng-container *ngSwitchCase="validityStatusCodeEnum.Transfer">
            <ins-insurance-coverage-data-list
                [purchasedProduct]="purchasedProduct"
                [display]="coverageDisplayEnum.Future"
            ></ins-insurance-coverage-data-list>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <wuc-tabset tabsetStyle="secondary" [(selectedTabIndex)]="selectedTabIndex">
                <wuc-tabset-item name="Huidige dekking">
                    <ins-insurance-coverage-data-list
                        [purchasedProduct]="purchasedProduct"
                        [display]="coverageDisplayEnum.Current"
                    ></ins-insurance-coverage-data-list>
                </wuc-tabset-item>
                <wuc-tabset-item
                    name="Dekking per {{ purchasedProduct?.coverage?.coveragesAdjustmentStartDate | dateFormat }}"
                >
                    <ins-insurance-coverage-data-list
                        [purchasedProduct]="purchasedProduct"
                        [display]="coverageDisplayEnum.Future"
                    ></ins-insurance-coverage-data-list>
                </wuc-tabset-item>
            </wuc-tabset>
        </ng-container>
    </ng-container>
</ng-container>
